import React from 'react';
import { FormGroup, Label, Input } from '../../../styles/components';

interface CustomerIdStepProps {
  customerId: string;
  onCustomerIdChange: (value: string) => void;
  providerName?: string;
}

export function CustomerIdStep({
  customerId,
  onCustomerIdChange,
  providerName
}: CustomerIdStepProps) {
  return (
    <>
      <div style={{
        marginBottom: '1rem',
        padding: '1rem',
        backgroundColor: '#f3f4f6',
        borderRadius: '0.5rem'
      }}>
        <p style={{ margin: 0, color: '#374151', fontSize: '0.875rem' }}>
          Enter the Customer ID provided by {providerName || 'the bank'}.
        </p>
      </div>
      <FormGroup>
        <Label htmlFor="customerId">Customer ID *</Label>
        <Input
          id="customerId"
          type="text"
          value={customerId}
          onChange={(e) => onCustomerIdChange(e.target.value)}
          placeholder="Enter Customer ID"
        />
        <small style={{ color: '#6b7280', marginTop: '0.5rem', display: 'block' }}>
          The Customer ID identifies your organisation to the bank (used together with the certificate signature).
        </small>
      </FormGroup>
    </>
  );
}
